"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomer = exports.sendCreateCustomerFailureEvent = exports.sendCreateCustomerEvent = void 0;
const constants_1 = require("../../constants/index.js");
const types_1 = require("../../types/index.js");
const tracking_1 = require("../tracking/index.js");
const parsers_1 = require("../../utils/parsers/index.js");
const clearNonNumericDigits = (str) => str === null || str === void 0 ? void 0 : str.replace(constants_1.NON_NUMERIC_REGEX, '');
const getCreateCustomerUrl = (id) => id ? `${constants_1.CREATE_CUSTOMER_URL}?page_id=${id}` : `${constants_1.CREATE_CUSTOMER_URL}`;
const getRecognitionPoint = (pageContent) => {
    if (!pageContent) {
        return types_1.VDCustomerOriginIds.paymentLink;
    }
    return `${pageContent.recognitionPoint.productId}::${pageContent.recognitionPoint.stage}`;
};
const getOptIns = (data, formData) => {
    var _a;
    const optInsValue = Boolean(data.optIns);
    let optInsOption = { email: optInsValue };
    if (formData) {
        const hasOptIns = (_a = formData.form) === null || _a === void 0 ? void 0 : _a.fields.filter((fields) => fields.id === 'optIns').length;
        if (!hasOptIns) {
            return {};
        }
        const shouldReturnWhatsAppOption = formData.id === 2 || (data.phoneNumber && !data.email);
        if (shouldReturnWhatsAppOption) {
            optInsOption = { whatsapp: optInsValue };
        }
    }
    return optInsOption;
};
const createCustomerBodyBuilder = (data, formData, options) => {
    var _a;
    return ({
        origin: {
            origin_id: getRecognitionPoint(formData),
            identifier: options.identifier,
        },
        email: (0, parsers_1.parseEmptyStringToUndefined)(data.email),
        full_name: (_a = data.fullName) === null || _a === void 0 ? void 0 : _a.trim(),
        document_number: clearNonNumericDigits(data.documentNumber),
        phone_number: data.phoneNumber && `+55${clearNonNumericDigits(data.phoneNumber)}`,
        opt_ins: getOptIns(data, formData),
    });
};
const sendCreateCustomerEvent = (target) => (0, tracking_1.sendEvent)((0, tracking_1.getCategory)(window.location.host, target), types_1.TRACKING_ACTIONS.signup, 'sucesso');
exports.sendCreateCustomerEvent = sendCreateCustomerEvent;
const sendCreateCustomerFailureEvent = (target) => (0, tracking_1.sendEvent)((0, tracking_1.getCategory)(window.location.host, target), types_1.TRACKING_ACTIONS.signup, 'erro:falha-na-api');
exports.sendCreateCustomerFailureEvent = sendCreateCustomerFailureEvent;
/**
 * O serviço "createCustomer" é responsável pela criação de um cliente
 * na Plataforma de Clientes de VD e retorna um token JWT do cliente identificado.
 *
 * @param customerData
 * @param formData
 * @param options - { identifier: string } - O identificador é o resellerSlug ou outro qualificador customizado
 * @returns SignUpResponseDTO
 */
const createCustomer = (customerData, formData, options) => fetch(getCreateCustomerUrl(formData === null || formData === void 0 ? void 0 : formData.id), {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(createCustomerBodyBuilder(customerData, formData, options)),
}).then((res) => {
    if (res.ok) {
        return res.json();
    }
    // fetch by default doesn't throw an error when the response is not ok
    throw new Error('Something went wrong');
});
exports.createCustomer = createCustomer;
